import React, { useEffect, useRef } from "react";
import "./VisualMerch.css";
import emailjs from '@emailjs/browser';

const VisualMerch = () => {
    const bannerRef = useRef(null);

    useEffect(() => {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth'
        });
    }, []);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) bannerRef.current.classList.add("visible");
            },
            { threshold: 0.3 }
        );
        if (bannerRef.current) observer.observe(bannerRef.current);
    }, []);

    return (
        <section className="visualmerch">
            {/* === SECCIÓN 1: Banner con animación === */}
            <div className="visualmerch-banner" ref={bannerRef}>
                <img src="/images/visualmerch/v1_exhibidor_v2.png" alt="exhibidor1" className="exhibidor1" />
                <img src="/images/visualmerch/Main File (View 1).png" alt="exhibidor2" className="exhibidor2" />
                <img src="/images/visualmerch/Display Stand Mockup.png" alt="display-merch" className="display-merch" />
                <div className="banner-texto">
                    <h3>Displays <br></br>y VISUAL MERCH</h3>
                    <img src="/images/logo/MotiPuntos.svg" style={{ height: '0.7rem' }}></img>
                    <p className="p-merch">Innovación en cada solución</p>
                </div>
            </div>

            {/* === SECCIÓN 2: Texto + Imagen edificio === */}
            <div className="visualmerch-info">
                <p className="subtitle-merch">we make it <span>happen.</span></p>

                <div className="info-contenido">
                    <div className="info-texto-merch">
                        <div className="tag-merch"> <img src="/images/visualmerch/_x31_8.svg" style={{ height: '1rem' }}></img> Visual Merchandising</div>
                        <h2>
                            Displays y visual merchandising que harán que
                            <span> tu producto vuele</span>
                        </h2>
                        <p>
                            Creamos displays y materiales visuales que destacan tu marca con impacto e innovación. <b>Desde pósters y banners hasta telas publicitarias y displays</b>, ofrecemos impresión de visual merch de alta calidad para cualquier superficie.
                            diseñamos soluciones que garantizan que tu producto sobresalga en cualquier espacio.
                        </p>
                        <p className="cta-merch">
                            En Moti Digital lo hacemos posible, <a href="#cotiza">solicita tu cotización:</a>
                        </p>
                        <div className="input-wrapper-merch">
                             <form
                                onSubmit={async (e) => {
                                    e.preventDefault();
                                    const form = e.target;
                                    const button = form.querySelector("button");
                                    const input = form.querySelector("input");

                                    button.disabled = true;
                                    const originalText = button.textContent;
                                    button.textContent = "Enviando...";

                                    try {
                                        const serviceID = "service_lxg5sht";
                                        const templateID = "template_epehkcc";
                                        const publicKey = "4f0iRLKGvmXsd0ASA";

                                        const params = {
                                            from_name: input.value, 
                                            message: `Me interesan sus productos de Visual merch. Me pueden contactar al correo ${input.value}, me estoy contactando desde motidigital.com `,
                                        };

                                        console.log("📤 Enviando con EmailJS...");
                                        console.log({ serviceID, templateID, publicKey, params });

                                        const res = await emailjs.send(serviceID, templateID, params, publicKey);
                                        console.log("✅ Respuesta EmailJS:", res);

                                        if (res.status === 200) {
                                            button.textContent = "Enviado ✔";
                                            input.value = "";
                                            setTimeout(() => {
                                                button.textContent = originalText;
                                                button.disabled = false;
                                            }, 3000);
                                        } else {
                                            throw new Error("Error en el envío");
                                        }
                                    } catch (error) {
                                        console.error("❌ Error al enviar con EmailJS:", error);

                                        button.textContent = "Error ✖";
                                        setTimeout(() => {
                                            button.textContent = originalText;
                                            button.disabled = false;
                                        }, 2500);
                                    }
                                }}
                            >
                                <input
                                    type="email"
                                    name="email"
                                    placeholder="Tu correo electrónico"
                                    required
                                />
                                <button type="submit">Empecemos</button>
                            </form>

                        </div>
                    </div>

                    <div className="info-imagen">
                        <img src="/images/visualmerch/22.png" alt="Visual merch en edificio" />
                    </div>
                </div>
            </div>
            <div className="visualmerch-final">
                <img src="/images/logo/MotiPuntos.svg" alt="puntos" className="dots" />
                <h2>
                    ¿Listo para hacer crecer <br />
                    <span>tu empresa?</span>
                </h2>

                {/* Doble marquee - VERSIÓN SIMPLE */}
                <div className="visualmerch-marquees">
                    <div className="marquee line1">
                        <span>
                            FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE ·
                            FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE ·
                            FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE ·
                            FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE ·
                            FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE ·
                            FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE ·
                            FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE ·
                            FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE ·
                            FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE ·
                            FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE ·
                            FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE ·
                            FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE ·
                            FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE ·
                            FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE ·
                            FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE ·
                            FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE ·
                            FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE ·
                            FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE ·
                            FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE ·
                            FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE ·
                            FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE ·
                            FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE ·
                            FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE ·

                        </span>
                        <span>
                            FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE ·
                            FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE ·
                            FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE ·
                            FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE ·
                            FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE ·
                            FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE ·
                            FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE ·
                            FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE ·
                            FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE ·
                            FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE ·
                            FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE ·
                            FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE ·
                            FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE ·
                            FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE ·
                            FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE ·
                            FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE ·
                            FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE ·
                            FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE ·
                            FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE ·
                            FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE ·
                            FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE ·
                            FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE ·
                            FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE · FABRICACIÓN DE ·

                        </span>
                    </div>

                    <div className="marquee line2">
                        <span>
                            EXHIBIDORES A LA MEDIDA · EXHIBIDORES A LA MEDIDA · EXHIBIDORES A LA MEDIDA ·
                            EXHIBIDORES A LA MEDIDA · EXHIBIDORES A LA MEDIDA · EXHIBIDORES A LA MEDIDA ·
                            EXHIBIDORES A LA MEDIDA · EXHIBIDORES A LA MEDIDA · EXHIBIDORES A LA MEDIDA ·
                            EXHIBIDORES A LA MEDIDA · EXHIBIDORES A LA MEDIDA · EXHIBIDORES A LA MEDIDA ·
                            EXHIBIDORES A LA MEDIDA · EXHIBIDORES A LA MEDIDA · EXHIBIDORES A LA MEDIDA ·
                            EXHIBIDORES A LA MEDIDA · EXHIBIDORES A LA MEDIDA · EXHIBIDORES A LA MEDIDA ·
                            EXHIBIDORES A LA MEDIDA · EXHIBIDORES A LA MEDIDA · EXHIBIDORES A LA MEDIDA ·
                            EXHIBIDORES A LA MEDIDA · EXHIBIDORES A LA MEDIDA · EXHIBIDORES A LA MEDIDA ·
                            EXHIBIDORES A LA MEDIDA · EXHIBIDORES A LA MEDIDA · EXHIBIDORES A LA MEDIDA ·
                            EXHIBIDORES A LA MEDIDA · EXHIBIDORES A LA MEDIDA · EXHIBIDORES A LA MEDIDA ·
                            EXHIBIDORES A LA MEDIDA · EXHIBIDORES A LA MEDIDA · EXHIBIDORES A LA MEDIDA ·
                        </span>
                        <span>
                            EXHIBIDORES A LA MEDIDA · EXHIBIDORES A LA MEDIDA · EXHIBIDORES A LA MEDIDA ·
                            EXHIBIDORES A LA MEDIDA · EXHIBIDORES A LA MEDIDA · EXHIBIDORES A LA MEDIDA ·
                            EXHIBIDORES A LA MEDIDA · EXHIBIDORES A LA MEDIDA · EXHIBIDORES A LA MEDIDA ·
                            EXHIBIDORES A LA MEDIDA · EXHIBIDORES A LA MEDIDA · EXHIBIDORES A LA MEDIDA ·
                            EXHIBIDORES A LA MEDIDA · EXHIBIDORES A LA MEDIDA · EXHIBIDORES A LA MEDIDA ·
                            EXHIBIDORES A LA MEDIDA · EXHIBIDORES A LA MEDIDA · EXHIBIDORES A LA MEDIDA ·
                            EXHIBIDORES A LA MEDIDA · EXHIBIDORES A LA MEDIDA · EXHIBIDORES A LA MEDIDA ·
                            EXHIBIDORES A LA MEDIDA · EXHIBIDORES A LA MEDIDA · EXHIBIDORES A LA MEDIDA ·
                            EXHIBIDORES A LA MEDIDA · EXHIBIDORES A LA MEDIDA · EXHIBIDORES A LA MEDIDA ·
                            EXHIBIDORES A LA MEDIDA · EXHIBIDORES A LA MEDIDA · EXHIBIDORES A LA MEDIDA ·
                            EXHIBIDORES A LA MEDIDA · EXHIBIDORES A LA MEDIDA · EXHIBIDORES A LA MEDIDA ·
                        </span>
                    </div>
                </div>


                {/* Slider semicircular */}
                <div className="visualmerch-slider">
                    <div className="slider-track">
                        <img src="/images/visualmerch/slider/1.png" alt="img1" />
                        <img src="/images/visualmerch/slider/2.png" alt="img2" />
                        <img src="/images/visualmerch/slider/3.png" alt="img3" />
                        <img src="/images/visualmerch/slider/4.png" alt="img4" />
                        <img src="/images/visualmerch/slider/5.png" alt="img5" />
                    </div>
                </div>
            </div>
            {/* === SECCIÓN 3: Opción estratégica === */}
            <div className="visualmerch-opcion">
                <img src="/images/logo/Moti Logo.svg" alt="decorativo" className="opcion-icon" />

                <div className="opcion-card">
                    <div className="opcion-left">
                        <h2>Tu producto está listo,<br />pero ¿ya destaca?</h2>
                        <p>Ayúdalo a destacar con visual merchandising</p>
                        <button className="btn-cotizar">Cotizar ahora</button>
                    </div>

                    <div className="opcion-right">
                        <ul className="opcion-list">
                            <li>Etiquetas con dato variable</li>
                            <li>Pósters con promociones</li>
                            <li>Stickers llamativos</li>
                            <li>Invitaciones para influencers</li>
                            <li>Flyers y brochures</li>
                            <li>Postales y tarjetas</li>
                            <li>Señalética para tu tienda</li>
                            <li>Displays de acrílico o cartón</li>
                            <li>Glorificadores personalizados</li>
                            <li>Acrílicos decorativos</li>
                            <li>Papelería personalizada</li>
                            <li>Papel de regalo para packaging</li>
                        </ul>
                    </div>

                </div>
            </div>
            <div className="visualmerch-faq">
                <img src="/images/logo/MotiPuntos.svg" alt="puntos" className="dots" />
                <h2>Preguntas frecuentes</h2>
                <div className="faq-contenedor">
                    {/* Lado izquierdo - Acordeón */}
                    <div className="faq-lista">
                        <details>
                            <summary>¿Qué tipos de displays ofrecen?</summary>
                            <p>
                                Manejamos una amplia variedad de displays, desde exhibidores de cartón hasta estructuras metálicas personalizadas,
                                incluyendo acrílicos, stands plegables, displays de piso y exhibidores para mostrador.
                            </p>
                        </details>

                        <details>
                            <summary>¿Qué es el visual merchandising?</summary>
                            <p>
                                El visual merchandising es la práctica de organizar y presentar productos de manera atractiva en el punto de venta
                                para estimular las compras. Incluye displays, señalética, y elementos gráficos que mejoran la experiencia del cliente.
                            </p>
                        </details>

                        <details>
                            <summary>¿Ofrecen servicios de diseño?</summary>
                            <p>
                                Sí, nuestro equipo de diseñadores gráficos puede crear conceptos desde cero o adaptar tus materiales existentes
                                para garantizar que tu visual merchandising sea coherente con tu identidad de marca.
                            </p>
                        </details>

                        <details>
                            <summary>¿Los materiales son eco-friendly?</summary>
                            <p>
                                Ofrecemos opciones sostenibles como cartón reciclado, bioplásticos y tintas ecológicas.
                                También tenemos materiales reutilizables para reducir el impacto ambiental.
                            </p>
                        </details>

                        <details>
                            <summary>¿Puedo poner dato variable en mi visual merchandising?</summary>
                            <p>
                                Absolutamente. Contamos con tecnología de impresión digital que permite personalizar cada pieza con datos variables
                                como precios, códigos QR, nombres de productos o información específica por ubicación.
                            </p>
                        </details>
                    </div>

                    {/* Lado derecho - Contacto */}
                    <div className="faq-contacto">
                        <h3>¿Tienes más dudas?</h3>
                        <p>No dudes en contactarnos para más información.</p>

                        <div className="contacto-email">
                            <div className="email-box-merch">
                                <img src="/images/visualmerch/mail.svg" alt="email" />
                                <span>COTIZACIONES@MOTIDIGITAL.COM</span>
                                <button>Agendar una llamada</button>
                            </div>
                            <button className="btn-whatsapp"> Cotiza tu proyecto</button>
                        </div>

                        <div className="faq-img">
                            <img src="/images/granformato/faq-banner.png" alt="FAQ" />
                        </div>
                    </div>
                </div>
            </div>

        </section>

    );
};


export default VisualMerch;